import { create } from "zustand";

interface AuthState {
  role: string;
  setRole: (role: string) => void;
  auth: any;
  setAuth: (auth: any) => void;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  role: 'USER', // Default role
  setRole: (role) => set({ role }),
  auth: null,
  setAuth: (auth) => set({ auth }),
}));

